import * as React from 'react';

//hook
import { UserConsumer } from '../hooks/context/UserContext';
import { useApi } from '../hooks/useApi';

//type
import { ForgetPassowrdReqType } from '../api/forget&resetPassword/type/ForgetAndResetPassword';

//api
import { PostForgetPasswordApi } from '../api/forget&resetPassword/PostForgetPasswordApi';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CircularProgress from '@mui/material/CircularProgress';



// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//image
import login_logo from '../assets/login/login_logo.png'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ForgetPasswordProps {
  openForgetPassword: boolean,
  setOpenForgetPassword: (open: boolean) =>void
  setOpenResetPassword: (open: boolean) =>void
}

const ForgetPassword = ({openForgetPassword, setOpenForgetPassword, setOpenResetPassword}: ForgetPasswordProps) => {
    const {t} = useTranslation()
    const ForgetPasswordSchema = Yup.object().shape({
        phone: Yup.string()
        //test(name, message, testFunction)
        .test(
            "len",t("phone_lenght"),
            (value) => {
            if (!value) return false;
            const numberWithoutCode = value.slice(4);
            return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
            }
        ).required(t("phone_required")),
    });
    const {
        loading: forgetPasswordLoading,
        error: forgetPasswordError,
        HandlerApi: forgetPasswordApi
    } = useApi(PostForgetPasswordApi, "POST");
      let {setUserData} = UserConsumer()
    const handleClose = () => {
        setOpenForgetPassword(false);
    };
    const handleSubmit = async (values: ForgetPassowrdReqType)=> {
        console.log(values)
        const result = await forgetPasswordApi(values);
        setUserData(result.data)
        setOpenResetPassword(true)
        handleClose();
    }
    return (
    <div>
        <Dialog 
        open={openForgetPassword}
        onClose={handleClose}
        slots={{
        transition: Transition,
        }}
        disableRestoreFocus
        >
            <DialogTitle className='flex gap-3'>
            <img className='w-[30px] h-[30px]' src={login_logo} alt='no=photo'/>
            <p>{t("gettak")}</p>
            </DialogTitle>
            <div className='flex justify-between max-sm:flex-col pb-5'>
            <div className='w-full'>
                <DialogTitle>
                <p className='text-[12px] text-darkColor'>{t("please_enter_the_phone_number_you_used_to_login")}</p>
                </DialogTitle>
                <DialogContent>
                <Formik
                initialValues={{phone: ''}}
                validationSchema={ForgetPasswordSchema}
                onSubmit={(values)=>handleSubmit(values)}
                >
            {({ values,touched, errors,setFieldValue }) => (
                <Form>
                <div className="mt-5">
                    <PhoneInput
                    country={"sy"}
                    onlyCountries={["sy"]}
                    disableDropdown={true}
                    enableSearch={true}
                    value={values.phone}
                    onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                    inputStyle={{
                        borderRadius: "4px",
                        width: "100%",
                        height: "56px",
                        border: touched.phone && errors.phone ? "1px solid red" : "",
                    }}
                    buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                    containerStyle={{
                        display: "flex",
                        flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                    }}
                    inputProps={{
                        autoComplete: "phone",
                    }}
                    />
                    <div className="text-red-500 text-sm mt-1">
                    {touched.phone && errors.phone ? errors.phone : ""}
                    </div>
                </div>
                <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                    <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' type="submit">
                    {forgetPasswordLoading 
                    ? <CircularProgress className='w-1 h-1'/>
                    :t("confirm")
                    }
                    </Button>
                </DialogActions>
                </Form>
            )}
                </Formik>
                </DialogContent>
            </div>
            </div>
        </Dialog>
    </div>
    )
}

export default ForgetPassword
